<script setup>
// import { BFormInput} from 'bootstrap-vue-next';
import HeaderContent from '@/components/HeaderContent.vue';
import DataTable from '@/components/DataTable.vue';
// import FilterSearch from '@/components/FilterSearch.vue';
import ButtonCta from '@/components/ButtonCta.vue';
import ActionContent from '@/components/ActionContent.vue';
import InventoryModalForm from '../InventoryModalForm.vue';
import { ref,inject,onMounted } from 'vue'
import dateFormatter from '@/composable/dateFormatter';

const inventoryModal = ref(false)
const repositories = inject('repositories');

const invetoryByLocationRepository = repositories ? repositories.inventoryWarehouse : null;

const fields =[
    
    { key: 'inventory.item_name', label: 'Name',class: 'text-left'},
    { key: 'inventory.type', label: 'Category',class: 'text-center'},
    { key: 'total', label: 'Total',class: 'text-center'},
    { key: 'last_update', label: 'Last Update',thClass:'text-center',tdClass:'text-center'},
    { key: 'updated_by', label: 'Updated By',class: 'text-center'},
    { key: 'action', label: 'Action',thClass:'text-center',tdClass:'text-center'},    
]
const inventoryData = ref([])
const getAll = async () => {
    await invetoryByLocationRepository.getAll().then((res) => {
    inventoryData.value = res.data.data.map(item => (  
        {
            ...item, 
            last_update: dateFormatter(item.last_update),
            updated_by : 'Mr example data',

        } 
    ))
    inventoryData.value.reverse()
    console.log(res.data)
    }).catch(err => {
    console.error(err)
    })
};

    
onMounted(() => {
    getAll();
});
</script>

<template>
    <HeaderContent title="Warehouse Inventory"/>
    
    <ActionContent :filterDate="false" :cta="false"></ActionContent>

    <!-- Statistic -->
    <div class="mt-4 table-responsive bg-white rounded-3 mb-0">
        <div class="px-4 pt-4 d-lg-flex align-items-center justify-content-start">
            <ButtonCta class="" v-if=" inventoryName !== 'spoil' && inventoryName !== 'overall' " text="Add New" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta>
        </div>

        <DataTable :data="inventoryData" :header="fields" :currentPage="currentPage" :custom-actions="customActions"></DataTable>
    </div>

      <!-- Modalform -->
      <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>
</template>

<script>

const customActions = [
    {
        label: 'History',
        variant: 'secondary',
        icon: 'fas fa-history',
        action: (item) => {
        console.log('Payment action clicked for:', item);
        // Implement your Payment logic here
        }
    },
    {
        label: 'Edit',
        variant: 'success',
        icon: 'fas fa-edit',
        action: (item) => {
        console.log('Info action clicked for:', item);
        // Implement your Info logic here
        }
    },
    {
        label: 'Delete',
        variant: 'danger',
        icon: 'fas fa-trash',
        action: (item) => {
        console.log('Info action clicked for:', item);
        // Implement your Info logic here
        }
    },
]

</script>

<style>
@media screen and (max-width: 576px) {
    
    
}
</style>